"use client";

import { setCookie, getCookie, deleteCookie } from "@/lib/cookieUtils";

const TOKEN_KEY = "artha_token";

export const authService = {
    getToken: (): string | null => {
        if (typeof window === "undefined") return null;
        return localStorage.getItem(TOKEN_KEY) || getCookie(TOKEN_KEY);
    },

    setToken: (token: string): void => {
        if (typeof window === "undefined") return;
        localStorage.setItem(TOKEN_KEY, token);

        // Also set a non-HttpOnly cookie for the middleware to detect session presence
        // This allows the Next.js middleware to do coarse-grained redirects.
        // The backend will still verify the actual token in the Authorization header.
        setCookie(TOKEN_KEY, token, 7 * 24 * 60 * 60);
    },

    clearToken: (): void => {
        if (typeof window === "undefined") return;
        localStorage.removeItem(TOKEN_KEY);
        deleteCookie(TOKEN_KEY);
    },

    isAuthenticated: (): boolean => {
        return !!authService.getToken();
    },
};
